export default __webpack_public_path__ + "static/media/ico-search.1fb4e975.svg";